import * as React from "react";
import type { SVGProps } from "react";
const SvgPhoneHornRinging = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M14.01 3c0-.55.45-1 1-1 3.86 0 7 3.14 7 7 0 .55-.45 1-1 1s-1-.45-1-1c0-2.76-2.24-5-5-5-.55 0-1-.45-1-1m6.37 11.07-5-2c-.46-.18-.98 0-1.23.41l-1 1.67c-1.34-.82-2.48-1.96-3.3-3.3l1.67-1c.42-.25.6-.77.41-1.23l-2-5A1 1 0 0 0 9 2.99H5c-1.65 0-3 1.35-3 3.06.52 8.57 7.37 15.42 16 15.94 1.65 0 3-1.35 3-3v-4a1 1 0 0 0-.63-.93zM19.01 19c0 .55-.45 1-.94 1-7.56-.46-13.6-6.5-14.06-14 0-.55.45-1 1-1h3.32l1.43 3.58-1.77 1.06c-.45.27-.61.83-.38 1.3 1.16 2.35 3.1 4.29 5.45 5.45.47.23 1.03.06 1.3-.38l1.06-1.77L19 15.67v3.32zm-4-11c.55 0 1 .45 1 1s.45 1 1 1 1-.45 1-1c0-1.65-1.35-3-3-3-.55 0-1 .45-1 1s.45 1 1 1"
      clipRule="evenodd"
    />
  </svg>
);
export default SvgPhoneHornRinging;
